import { useEffect, useState } from "react";
import { useCatalogsStore } from "stores/catalogs";
import { getInitLanguage } from "helpers/language";
import { useCurrenciesData } from "queries/useCurrenciesData";
import { useLanguagesData } from "queries/useLanguagesData";
import { useLocalizationData } from "queries/useLocalizationData";
import { useLocalizationStore } from "stores/localization";

const initStatuses = {
  currencies: false,
  languages: false,
  localization: false,
};

export const useInitLandingLoading = () => {
  const [statuses, setStatuses] = useState(initStatuses);
  const appLang = getInitLanguage();

  const { isCurrenciesLoaded, isLanguagesLoaded, isLocalizationLoaded } =
    useCatalogsStore((state) => ({
      isCurrenciesLoaded: state.isCurrenciesLoaded,
      isLanguagesLoaded: state.isLanguagesLoaded,
      isLocalizationLoaded: state.isLocalizationLoaded,
    }));
  const changeLanguage = useLocalizationStore((state) => state.changeLanguage);

  useCurrenciesData();
  useLanguagesData();
  useLocalizationData(appLang);

  useEffect(() => {
    if (isCurrenciesLoaded) {
      setStatuses((prev) => ({ ...prev, currencies: true }));
    }
    if (isLanguagesLoaded) {
      setStatuses((prev) => ({ ...prev, languages: true }));
    }
    if (isLocalizationLoaded) {
      setStatuses((prev) => ({ ...prev, localization: true }));
    }
  }, [isCurrenciesLoaded, isLanguagesLoaded, isLocalizationLoaded]);

  useEffect(() => {
    changeLanguage(appLang);
  }, [changeLanguage, appLang]);

  return {
    progress: Object.values(statuses).filter((status) => status).length,
    total: Object.values(statuses).length,
  };
};
